import PusherJS from 'pusher-js';
import { deliveryteamOrdersApiClient } from '@api-client/deliveryteam_orders';
import { toast } from '@/ui-plus/sonner';

let connectionErrorToastId: string | number | undefined = undefined;

export const pusherClient = new PusherJS(import.meta.env.PUBLIC_SOKETI_APP_KEY, {
    wsPath: '/soketi',
    wsHost: `soketi.${import.meta.env.PUBLIC_DOMAIN_NAME}`,
    cluster: 'cluster',
    forceTLS: true,
    enabledTransports: [
        'ws',
        'wss'
    ],
    authorizer: (channel) => {
        return {
            authorize: async (socketId, callback) => {
                const { data, error } = await (await deliveryteamOrdersApiClient.pusher_courier_auth.$post({
                    json: {
                        socket_id: socketId,
                        channel_name: channel.name
                    }
                })).json();
                if (error) {
                    callback(new Error(error.message || "Unknown error"), null);
                } else {
                    callback(null, data);
                }
            }
        };
    },
});

pusherClient.connection.bind('state_change', (states: { previous: string; current: string }) => {
    const { current } = states;

    // Clear any existing error toast when reconnected
    if (current === 'connected') {
        if (connectionErrorToastId !== undefined) {
            toast.dismiss(connectionErrorToastId);
            connectionErrorToastId = undefined;
        }
        return;
    }

    // Detect permanent connection failures
    if (current === 'failed' || current === 'unavailable') {
        console.warn('socket connection error:', states);
        // Only show the reload warning if we don't already have one showing
        if (connectionErrorToastId === undefined) {
            connectionErrorToastId = 'placeholder-until-toast-created';
            connectionErrorToastId = toast.error('Connection lost. Please reload the page.', {
                duration: Infinity, // Show until dismissed or page reloaded
                dismissible: true,
                action: {
                    label: "Reload",
                    onClick: () => {
                        window.location.reload();
                    }
                }
            });
        }
    }
});